import { createIntegrationConnectionConfigurationClassMixin } from '../../../connection/configuration/IntegrationConnectionConfigurationMixin';

export interface ZenotiLocationConfigurationValid {
    type: 'VALID';
    centerId: string;
}

export interface ZenotiLocationConfigurationMissing {
    type: 'MISSING_CENTER_ID';
}

export type ZenotiLocationConfigurationUnion =
    | ZenotiLocationConfigurationMissing
    | ZenotiLocationConfigurationValid;

export class ZenotiLocationConfiguration extends createIntegrationConnectionConfigurationClassMixin<
    ZenotiLocationConfigurationUnion,
    'ZENOTI_LOCATION'
>('ZENOTI_LOCATION') { }
